import React from 'react';
import { Box, Paper, Typography, Button, Stack, Avatar, Divider } from '@mui/material';
import { Add } from '@mui/icons-material';
import dayjs from 'dayjs';
import { sxConfig } from './workspace.style';
import { getContrastColor, getInitials } from '../../../utils/helper';

const HistoryCard = ({ handleNewCrmTask, completedTasks }) => {
  return (
    <Paper sx={{ ...sxConfig.card, p: 3 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        mb={3}
      >
        <Typography variant="h6" fontWeight={700}>
          Előzmények
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Button variant="contained" startIcon={<Add />} onClick={handleNewCrmTask}>
            Új esemény
          </Button>
        </Stack>
      </Stack>

      <Stack spacing={0}>
        {completedTasks.map((item, index) => (
          <Stack
            key={item.id}
            direction="row"
            spacing={2}
            alignItems="stretch"
            sx={{ minHeight: index < completedTasks.length - 1 ? 75 : 'auto' }}
          >
            <Box
              sx={{
                flexShrink: 0,
                height: 40,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="body2" color="text.secondary">
                {dayjs(item.createdAt).format('YYYY.MM.DD. HH:mm')}
              </Typography>
            </Box>

            <Stack alignItems="center" flexShrink={0}>
              <Avatar
                sx={{
                  background: item.createdBy?.color || '#0076f8',
                  color: getContrastColor(item.createdBy?.color || '#0076f8'),
                }}
              >
                {getInitials(item.createdBy?.nickName ?? item.createdBy?.userName)}
              </Avatar>

              {index < completedTasks.length - 1 && (
                <Divider
                  orientation="vertical"
                  sx={{
                    borderRightWidth: 2,
                  }}
                />
              )}
            </Stack>

            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                pb: index < completedTasks.length - 1 ? 3 : 0,
              }}
            >
              <Stack>
                <Typography fontWeight={600} sx={{ overflowWrap: 'anywhere' }}>
                  {item.description}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  {item.createdBy?.nickName ?? item.createdBy?.userName}
                </Typography>
              </Stack>
            </Box>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
};

export default HistoryCard;
